import { M_Button, M_Fieldset, M_Header, M_InputTextField, M_Select, M_SwitchButton } from "../../../M_Components"
import { FieldTypeEnum } from "../../../enums/fieldTypeEnum"
import { useTranslation } from "react-i18next"
import { Calendar } from 'primereact/calendar';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { useState } from "react";

export const GridFilters = ({ fields, filterForm, changeFilterCallback }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;
    const [filters, setFilters] = useState({})

    const handleChangeValue = (filter, value) => {
        // Não converter para String se for null/undefined
        if (value === null || value === undefined || value === '') {
            const newFilters = { ...filters };
            delete newFilters[filter];
            setFilters(newFilters);
        } else {
            setFilters({
                ...filters,
                [filter]: value
            });
        }
    }

    const handleFilterClick = () => {
        // Converter strings 'true'/'false' em booleanos reais
        const processedFilters = {};
        Object.keys(filters).forEach(key => {
            const value = filters[key];
            if (value === 'true') {
                processedFilters[key] = true;
            } else if (value === 'false') {
                processedFilters[key] = false;
            } else {
                processedFilters[key] = value;
            }
        });
        
        changeFilterCallback(processedFilters);
    }

    const handleClearFiltersClick = () => {
        changeFilterCallback({});
        setFilters({});
    }

    return (
        <>
            <div className="filters-grid">
                <div className="filters-header">
                    <M_Header
                        color={'var(--color-white)'}
                        element={<div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: "10px", width: "100%", alignItems: 'center' }}>
                            <div className="text-title" style={{ marginRight: "auto" }}>
                                {t("NgeFilters")}
                            </div>
                            <div style={{ display: "flex" }}>
                                <M_Button
                                    tooltip={t("NgeClearFilters")}
                                    label={t("NgeClearFilters")}
                                    icon={<i className='pi pi-filter-slash'></i>}
                                    onClick={() => handleClearFiltersClick()}
                                />
                                <M_Button
                                    tooltip={t("NgeFilter")}
                                    label={t("NgeFilter")}
                                    icon={<i className='pi pi-filter'></i>}
                                    onClick={() => handleFilterClick()}
                                />
                            </div>
                        </div>}
                    />
                </div>
                <div className="filters-form">
                    {
                        fields?.filter(f => f.Type !== FieldTypeEnum.Relation).map(f => {
                            // Boolean
                            if (f.Type === FieldTypeEnum.Boolean || f.Type === 'Boolean') {
                                return <M_Select
                                    key={f.Code}
                                    label={f.Captions?.[currentLanguage]?.length > 0 ? f.Captions[currentLanguage] : f.Code}
                                    value={filters[f.Code] !== undefined ? filters[f.Code] : ''}
                                    options={[
                                        { label: t('All') || 'Todos', value: '' },
                                        { label: t('Yes') || 'Sim', value: 'true' },
                                        { label: t('No') || 'Não', value: 'false' }
                                    ]}
                                    onChange={(e) => handleChangeValue(f.Code, e.target.value)}
                                />
                            }

                            // Attachment
                            if (f.Type === FieldTypeEnum.Attachment || f.Type === 'Attachment') {
                                return <M_Select
                                    key={f.Code}
                                    label={f.Captions?.[currentLanguage]?.length > 0 ? f.Captions[currentLanguage] : f.Code}
                                    value={filters[f.Code] !== undefined ? filters[f.Code] : ''}
                                    options={[
                                        { label: t('All') || 'Todos', value: '' },
                                        { label: t('WithAttachment') || 'Com anexo', value: 'true' },
                                        { label: t('WithoutAttachment') || 'Sem anexo', value: 'false' }
                                    ]}
                                    onChange={(e) => handleChangeValue(f.Code, e.target.value)}
                                />
                            }

                            // Dropdown
                            if (f.Type === FieldTypeEnum.Dropdown || f.Type === 'Dropdown') {
                                return <M_Select
                                    key={f.Code}
                                    label={f.Captions?.[currentLanguage]?.length > 0 ? f.Captions[currentLanguage] : f.Code}
                                    value={filters[f.Code] || ''}
                                    options={f.DropdownItems?.map(i => ({
                                        label: i.Captions?.[currentLanguage] || i.DropdownItemId,
                                        value: i.DropdownItemId
                                    })) || []}
                                    onChange={(e) => handleChangeValue(f.Code, e.target.value)}
                                />
                            }

                            // Datetime
                            if (f.Type === 'Datetime') {
                                return <div key={f.Code}>
                                    <M_InputTextField
                                        label={f.Captions?.[currentLanguage]?.length > 0 ? f.Captions[currentLanguage] : f.Code}
                                        value={filters[f.Code] || ''}
                                        type="datetime-local"
                                        onChange={(e) => handleChangeValue(f.Code, e.target.value)}
                                    />
                                </div>
                            }

                            // Date
                            if (f.Type === 'Date') {
                                return <div key={f.Code}>
                                    <M_InputTextField
                                        label={f.Captions?.[currentLanguage]?.length > 0 ? f.Captions[currentLanguage] : f.Code}
                                        value={filters[f.Code] || ''}
                                        type="date"
                                        onChange={(e) => handleChangeValue(f.Code, e.target.value)}
                                    />
                                </div>
                            }

                            // Time
                            if (f.Type === 'Time') {
                                return <div key={f.Code}>
                                    <M_InputTextField
                                        label={f.Captions?.[currentLanguage]?.length > 0 ? f.Captions[currentLanguage] : f.Code}
                                        value={filters[f.Code] || ''}
                                        type="time"
                                        onChange={(e) => handleChangeValue(f.Code, e.target.value)}
                                    />
                                </div>
                            }

                            // Integer, Decimal, Currency - Input numérico
                            if (f.Type === 'Integer' || f.Type === 'Decimal' || f.Type === 'Currency') {
                                return <div key={f.Code}>
                                    <M_InputTextField
                                        label={f.Captions?.[currentLanguage]?.length > 0 ? f.Captions[currentLanguage] : f.Code}
                                        value={filters[f.Code] || ''}
                                        type={f.Type === 'Integer' ? 'int' : 'decimal'}
                                        onChange={(e) => handleChangeValue(f.Code, e.target.value)}
                                    />
                                </div>
                            }

                            // Default: Text input

                            return <div key={f.Code}>
                                <M_InputTextField
                                    label={f.Captions?.[currentLanguage]?.length > 0 ? f.Captions[currentLanguage] : f.Code}
                                    value={filters[f.Code] || ''}
                                    onChange={(e) => handleChangeValue(f.Code, e.target.value)} />
                            </div>
                        })
                    }
                </div>
            </div>
        </>
    )
}